var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { generateEnumerabilityPreventingEntropy } from "../utils/generateEnumerabilityPreventingEntropy.js";
class ServerId {
  constructor(value, entityName) {
    this.value = value;
    this.entityName = entityName;
  }
  get existsOnServer() {
    return true;
  }
  get uniqueValue() {
    return ServerId.formatUniqueValue(this.value, this.entityName);
  }
  static formatUniqueValue(id, entityName) {
    return `${entityName}_${id}`;
  }
}
class ClientGeneratedUuid {
  constructor(value) {
    this.value = value;
  }
  get existsOnServer() {
    return false;
  }
  get uniqueValue() {
    return this.value;
  }
}
const _UnpersistedEntityDummyId = class {
  constructor() {
    __publicField(this, "value");
    const enumerabilityPreventingEntropy = generateEnumerabilityPreventingEntropy(
      _UnpersistedEntityDummyId.entropyLength
    );
    this.value = `adminOnlyDummyId-${enumerabilityPreventingEntropy}-${_UnpersistedEntityDummyId.getNextSeed()}`;
  }
  get existsOnServer() {
    return false;
  }
  static matchesDummyId(candidate) {
    return typeof candidate === "string" && _UnpersistedEntityDummyId.dummyIdRegex.test(candidate);
  }
  get uniqueValue() {
    return this.value;
  }
};
let UnpersistedEntityDummyId = _UnpersistedEntityDummyId;
__publicField(UnpersistedEntityDummyId, "getNextSeed", (() => {
  let seed = 0;
  return () => seed++;
})());
__publicField(UnpersistedEntityDummyId, "entropyLength", 5);
__publicField(UnpersistedEntityDummyId, "dummyIdRegex", new RegExp(`^adminOnlyDummyId-\\d{${_UnpersistedEntityDummyId.entropyLength}}-\\d+$`));
export {
  ClientGeneratedUuid,
  ServerId,
  UnpersistedEntityDummyId
};
//# sourceMappingURL=RuntimeId.js.map
